import { useState } from "react";
import { useSite } from "@/components/site/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { api } from "@/lib/api";

export default function Contatti() {
  const c = useSite();
  useSeo("Contatti", "Contatta POWERCOM: sede, telefono, email e modulo per richiedere informazioni e preventivi gratuiti.");
  const ct = c.contacts || {};
  const [note, setNote] = useState({ cls: "", text: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const f = e.target;
    setSending(true);
    setNote({ cls: "", text: "Invio in corso..." });
    try {
      const { data } = await api.post("/contact", {
        tipo: "Richiesta informazioni — Contatti",
        nome: f.nome.value,
        email: f.email.value,
        telefono: f.telefono.value,
        oggetto: f.oggetto.value,
        messaggio: f.messaggio.value,
      });
      setNote({ cls: "ok", text: data.message });
      f.reset();
    } catch {
      setNote({ cls: "err", text: "Errore nell'invio. Riprova più tardi." });
    } finally {
      setSending(false);
    }
  };

  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(ct.map_query || ct.address || "Roma")}&output=embed`;

  return (
    <>
      <section className="page-hero">
        <div className="container reveal">
          <span className="eyebrow light">Contatti — Dove siamo</span>
          <h1>Parliamo del tuo prossimo progetto.</h1>
          <p>Compila il modulo o usa i recapiti qui sotto: ti risponderemo al più presto.</p>
        </div>
      </section>

      <section className="section">
        <div className="container contact-grid">
          <div className="contact-info reveal">
            <span className="eyebrow">Recapiti</span>
            <h2>Dove siamo.</h2>
            <p>Siamo a tua disposizione per informazioni, sopralluoghi e preventivi gratuiti.</p>
            <ul className="contact-list">
              <li><strong>Sede</strong><span style={{ fontWeight: 700 }}>{ct.company}</span>{ct.address}</li>
              <li><strong>Telefono</strong>{ct.phone}</li>
              <li><strong>Email</strong>{ct.email}</li>
              {ct.vat && <li><strong>P.IVA</strong>{ct.vat}</li>}
              <li><strong>Orari</strong>{ct.hours}</li>
            </ul>
          </div>

          <div className="form-card reveal">
            <form onSubmit={submit} data-testid="contatti-form">
              <div className="field"><label>Nome e cognome *</label><input name="nome" required placeholder="Mario Rossi" data-testid="contatti-nome" /></div>
              <div className="field"><label>Email *</label><input name="email" type="email" required placeholder="mario@esempio.it" data-testid="contatti-email" /></div>
              <div className="field"><label>Telefono</label><input name="telefono" placeholder="+39 333 1234567" /></div>
              <div className="field"><label>Servizio di interesse</label>
                <select name="oggetto" data-testid="contatti-oggetto">
                  <option>Telecomunicazioni / Fibra ottica</option>
                  <option>Impianti Elettrici ed Elettronici</option>
                  <option>Videosorveglianza</option>
                  <option>Allarme Intrusione</option>
                  <option>Antincendio</option>
                  <option>Idrico-sanitari</option>
                  <option>Climatizzazione / Trattamento aria</option>
                  <option>Altro</option>
                </select>
              </div>
              <div className="field"><label>Messaggio *</label><textarea name="messaggio" rows="4" required placeholder="Descrivi la tua richiesta..." data-testid="contatti-messaggio" /></div>
              <button className="btn full" disabled={sending} data-testid="contatti-submit">Invia richiesta</button>
              {note.text && <p className={`form-note ${note.cls}`} data-testid="contatti-note">{note.text}</p>}
            </form>
          </div>
        </div>

        <div className="container">
          <div className="map-wrap reveal">
            <iframe title="Dove siamo" loading="lazy" src={mapSrc} />
          </div>
        </div>
      </section>
    </>
  );
}
